import React from 'react';
import './Spb.css';

import { useAppSelector } from 'hooks/redux';
import { pathSpb } from 'config';

import { MoreArrow } from 'components';
import { spbSelector } from 'store/ducks/homepage/selectors/spbSelector';
// import { personsSelector } from 'store/ducks/homepage/selectors/personsSelector';

export function Spb() {
  const spbPosts = useAppSelector(spbSelector);

  return (
    <section className="video">
      <h2 className="page-title video__title">Цифровой Петербург</h2>
      <MoreArrow type="video" link={pathSpb}>
        Все материалы
      </MoreArrow>
      {spbPosts &&
        spbPosts.length > 0 &&
        spbPosts.map(item => {
          const { id, link, img, title, date, exclusive_material } = item;
          return (
            <article className="card card--m" key={id}>
              <a className="materials__link" href={link}>
                <img src={img} alt={title} className="materials__img" />
                <div className="materials__common">
                  <h3
                    className="materials__title"
                    dangerouslySetInnerHTML={{ __html: title }}
                  ></h3>
                  <div className="materials__date">{date}</div>
                </div>
              </a>
              {exclusive_material && (
                <div className="tag exclusive">Эксклюзив</div>
              )}
            </article>
          );
        })}
    </section>
  );
}
